import { Upload } from "@mui/icons-material";
import { Button } from "@mui/material";
import { useEffect, useState } from "react";
import { Controller, useFormContext } from "react-hook-form";
import axios from "axios";

export const UploadController = ({ ...rest }) => {
  const { control, register, getValues, watch, setValue } = useFormContext();
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [preview, setPreview] = useState([]);
  const handleChange = (e) => {
    setValue(`${rest.name}_files`, e.target.files); // you get all the files object here
    setUploadedFiles(e.target.files);
  };

  // new changes
  const onChange = async(e)=>{
    const fieldName = e.target.name
    const files = e.target.files;
    const formData = new FormData();
    setUploadedFiles(e.target.files);
    for(let i=0; i<files.length; i++)
    {
      formData.append(`${fieldName}`,files[i])
    }
    for(let data of formData.entries())
    {
      console.log(data);
    }
    try {
      let imageNames = []
      let logoName = ''      
      const {data} = await axios.post("http://localhost:3000/api/v1/images",formData, { 
        headers:{"Content-Type": "multipart/form-data"} 
      });
      
      data.data.map((item)=>{
        if(item.field === 'images') 
          {
            imageNames.push(item.key)
          }
        else{
          logoName = item.key
        }
      });
      setValue(`images_files`, imageNames);
      setValue(`logo_files`, logoName);
      // console.log('Image Name:', imageNames);
      // console.log('Logo Name:', logoName);
    }
    catch(error)
    {
      console.log(error);
    }
  }

  useEffect(() => {
    let arr = [];
    for (let index = 0; index < uploadedFiles.length; index++) {
      debugger;
      let imageUrl = URL.createObjectURL(uploadedFiles[index]);
      arr.push(imageUrl);
    }
    setPreview([...arr]);
  }, [uploadedFiles]);
  return (
    <>
      <Controller
        {...rest}
        render={({ field, fieldState: { invalid, error } }) => (
          <Button
            variant={rest.variant}
            component="label"
            {...field}
            startIcon={<Upload />}
          >
            {rest.label}
            <input
              type="file"
              name={rest.name}
              accept={rest.accept}
              hidden
              onChange={onChange}
              error={invalid}
              helperText={invalid ? error.message : ""}
              multiple={rest.multiple}
            />
          </Button>
        )}
        control={control}
        defaultValue={rest.defaultValue}
      />
      {/* {file ? <img src={require(file)} /> : "Nothing"} */}
      {preview && preview.length
        ? preview.map((url) => {
            return <img src={url} />;
          })
        : "No name"}
    </>
  );
};
